import * as React from "react";
import { Alert, Box, Button, Modal, SpaceBetween } from "@amzn/awsui-components-react";
import { AppError } from "@amzn/ask-legal-domain";

/** Modal shown when a draft already exists (409 conflict). */
export const DraftConflictModal = (props: {
    onContinueEditing: () => void;
    onDiscardAndCreate: () => void;
    isDiscarding: boolean;
    discardError?: AppError;
    onCancel: () => void;
}) => {
    return (
        <Modal
            visible={true}
            header="Draft already exists"
            onDismiss={() => { if (!props.isDiscarding) props.onCancel(); }}
            footer={
                <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button variant="link" onClick={props.onCancel} disabled={props.isDiscarding}>
                            Cancel
                        </Button>
                        <Button variant="normal" onClick={props.onDiscardAndCreate} loading={props.isDiscarding}>
                            Discard & Create New
                        </Button>
                        <Button variant="primary" onClick={props.onContinueEditing} disabled={props.isDiscarding}>
                            Continue Editing Existing Draft
                        </Button>
                    </SpaceBetween>
                </Box>
            }>
            <SpaceBetween size="s">
                <Alert type="info">
                    A draft already exists for this page. You can continue editing the existing draft
                    or discard it and create a new one from the selected version.
                </Alert>
                {props.discardError && (
                    <Alert type="error">
                        Failed to discard draft: {props.discardError.message || "Unknown error"}
                    </Alert>
                )}
            </SpaceBetween>
        </Modal>
    );
};
